import PropTypes from "prop-types";
import classes from "./Button.module.scss";

export const Button = ({ label, outline, onClick, variant, loading }) => {
  return (
    <button
      type={onClick ? "button" : "submit"}
      className={`${classes.button} ${outline ? classes["outline"] : ""} ${
        classes[variant]
      } ${loading ? classes["dim"] : ""}`}
      onClick={loading ? undefined : onClick}
    >
      {loading ? (
        <div data-testid={"loading"} className={classes["loading"]} />
      ) : (
        label
      )}
    </button>
  );
};

Button.propTypes = {
  /**
   * label to be shown inside the button
   */
  label: PropTypes.any,
  /**
   * onClick function of button (must be undefined for submit)
   */
  onClick: PropTypes.func,
  /**
   * set true to have an outlined button (possible to different variants)
   */
  outline: PropTypes.bool,
  /**
   * set variant to change the background color of button
   */
  variant: PropTypes.oneOf(["primary", "danger", "secondary", "gray"]),
  /**
   * set true to show a loading inside button
   */
  loading: PropTypes.bool,
};

Button.defaultProps = {
  label: undefined,
  onClick: undefined,
  outline: false,
  variant: "primary",
};
